import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-botoes-files',
  templateUrl: './botoes-files.component.html',
  styleUrls: ['./botoes-files.component.scss']
})
export class BotoesFilesComponent {
  @Output() OnClickApplyPDFButton: EventEmitter<void> =
    new EventEmitter<void>();
  @Output() OnClickApplyCSVButton: EventEmitter<void> =
    new EventEmitter<void>();
  @Output() OnClickApplyXLSXButton: EventEmitter<void> =
    new EventEmitter<void>();
  @Input() disablePDF: boolean = false;
  @Input() disableCSV: boolean = false;
  @Input() disableXLSX: boolean = false;

  constructor() {}
}
